import { Injectable } from '@angular/core';
import { BusinessType } from 'src/app/api/invoice/models';

@Injectable({
  providedIn: 'root',
})
export class RouteService {
  findRoute(module: string) {
    let routePrefix, routeCreate, businessType;

    switch (module) {
      case 'SALES':
        routePrefix = 'sales/invoice/credit/show/';
        routeCreate = 'sales/invoice/create-credit';
        businessType = BusinessType.Sales;
        break;
      case 'ACMS_SALES':
        routePrefix = 'acms-sales/acms-sales-invoice/credit/show/';
        routeCreate = 'acms-sales/acms-sales-invoice/create-credit';
        businessType = BusinessType.AcmsSales;
        break;
      case 'SALES_WORK_ORDER':
        routePrefix = 'sales/invoice/credit/show/';
        routeCreate = 'sales/invoice/create-credit';
        businessType = BusinessType.SalesWorkOrder;
        break;
      case 'ACMS_SALES_WORK_ORDER':
        routePrefix = 'acms-sales/acms-sales-invoice/credit/show/';
        routeCreate = 'acms-sales/acms-sales-invoice/create-credit';
        businessType = BusinessType.AcmsSalesWorkOrder;
        break;
      case 'SALES_ORDER':
        routePrefix = 'sales-order/invoice/credit/show/';
        routeCreate = 'sales-order/invoice/create-credit';
        businessType = BusinessType.SalesOrder;
        break;
      case 'MCC':
        routePrefix = 'mcc/invoice/credit/show/';
        routeCreate = 'mcc/invoice/create-credit';
        businessType = BusinessType.Mcc;

        break;
      case 'FINANCE':
        routePrefix = 'finance/finance-invoice/credit/show/';
        routeCreate = 'finance/finance-invoice/create-credit';
        businessType = BusinessType.Finance;

        break;
      case 'FLIGHT':
        routePrefix = 'medevac/flight/invoice/credit/show/';
        routeCreate = 'medevac/flight/invoice/create-credit';

        businessType = BusinessType.Flight;

        break;
      case 'MEDVAC':
        routePrefix = 'medevac/first-aid/invoice/credit/show/';
        routeCreate = 'medevac/first-aid/invoice/create-credit';

        businessType = BusinessType.Medvac;

        break;
      case 'ESCORT':
        routePrefix = 'medevac/escort/escort-invoice/credit/show/';
        routeCreate = 'medevac/escort/invoice/create-credit';

        businessType = BusinessType.Escort;

        break;

      case 'TRAINING':
        routePrefix = 'training/invoice/credit/show/';
        routeCreate = 'training/invoice/create-credit';
        businessType = BusinessType.Training;

        break;

      case 'ACM':
        routePrefix = 'acms/invoice/credit/show/';
        routeCreate = 'acms/invoice/create-credit';
        businessType = BusinessType.Acm;
        break;

      case 'ACM_PARTIAL':
        routePrefix = 'acms/invoice/partial-credit/show/';
        routeCreate = 'acms/invoice/create-credit';
        businessType = BusinessType.Acm;
        break;

      case 'AIRPORT_MANAGEMENT_SERVICE':
        routePrefix = 'airport/airport-invoice/credit/show/';
        routeCreate = 'airport/airport-invoice/create-credit';
        businessType = BusinessType.AirportManagementService;
        break;

      default:
        routePrefix = 'sales/invoice/credit/show/';
        break;
    }

    return {
      detailRoute: routePrefix,
      createRoute: routeCreate,
      businessType,
    };
  }
}
